<script>
  import { format } from 'svelte-i18n';

  import { Step } from '@client/components/steps';

  import { BizCardPusherService } from '@client/services/bizcard-pusher';

  import { Bizcards, Push, PushStatus, Users } from './steps';
  import {
    checked,
    hasManualSelections,
    pushDisabled,
    reset as resetPusherStore,
    updateAssignmentAndUsers
  } from './stores/pusher';

  import { onMount } from 'svelte';

  export let pushed = false;

  let activeStep = 'select';
  let results = [];
  let pushing = false;

  let bizcard = null;
  let emailBody = $format('label.BIZCARD.ASSIGN.DEFAULT_EMAIL_BODY');
  let emailSubject = $format('label.BIZCARD.ASSIGN.DEFAULT_EMAIL_SUBJECT');
  let failures = 0;
  let progress = 0;
  let progressMessage = '';
  let sendEmail = false;
  let successes = 0;
  let total = 1;

  onMount(() => resetPusherStore());

  const handlePush = async () => {
    pushed = true;
    results = [];
    successes = 0;
    failures = 0;

    const steps = 2 + ($hasManualSelections ? 1 : 0) + (sendEmail ? 1 : 0);
    const stepSize = Math.floor(100 / steps);
    progress = 0;

    progressMessage = $format('label.BIZCARD.ASSIGN.ASSIGN_USERS');
    const result = await updateAssignmentAndUsers(bizcard);
    progress += stepSize * 2;

    if (!result.success) {
      progressMessage = $format('label.BIZCARD.ASSIGN.ASSIGN_FAILED');
      pushing = false;
      return;
    }

    if (sendEmail) {
      progressMessage = $format('label.BIZCARD.ASSIGN.SENDING_WELCOME_EMAILS');
      const emails = [...$checked];
      total = emails.length;
      pushing = true;
      progressMessage = '';

      BizCardPusherService.pushBizcards(emails, emailSubject, emailBody)
        .node('{username}', (node) => {
          const success = node.status !== 'error';
          results = [...results, node];
          if (success) successes += 1;
          else failures += 1;
        })
        .done(() => {
          pushing = false;
        });
    } else {
      progress = 100;
      progressMessage = '';
      pushing = false;
    }
  };

  $: current = results.length + 1;
</script>

{#if !pushed}
  <div>
    <Step
      active={activeStep === 'select'}
      nextDisabled={!bizcard}
      title={$format('label.CHOOSE_BUSINESS_CARD')}
      summary={bizcard}
      onNext={() => (activeStep = 'users')}
      onStep={() => (activeStep = 'select')}
    >
      <Bizcards bind:selected={bizcard} />
    </Step>

    <Step
      active={activeStep === 'users'}
      disabled={!bizcard}
      nextDisabled={!bizcard || $checked.size === 0 || $pushDisabled}
      title={$format('label.SELECT_USERS')}
      summary={$checked.size
        ? $format('label.BIZCARD.ASSIGN.USERS_COUNT', { values: { count: $checked.size } })
        : undefined}
      onBack={() => (activeStep = 'select')}
      onNext={() => (activeStep = 'push')}
      onStep={() => (activeStep = 'users')}
    >
      <Users />
    </Step>

    <Step
      active={activeStep === 'push'}
      disabled={$checked.size === 0}
      title={$format('label.REVIEW')}
      onBack={() => (activeStep = 'users')}
      onStep={() => (activeStep = 'push')}
    >
      <Push onPush={handlePush} bind:body={emailBody} bind:subject={emailSubject} bind:sendEmail />
    </Step>
  </div>
{:else}
  <PushStatus {current} {failures} {progress} {progressMessage} {pushing} {results} {successes} {total} />
{/if}
